import React, { useEffect, useRef } from 'react'
import { Grid, TextField } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { useFormContext } from 'react-hook-form'
import useCookieBanner from 'hooks/useCookieBanner'
import useStyles from './styles'

import { LanguageCustomization } from '../'
import { ButtonTextFields } from './components'

import constants from 'constants/index'

const { ORDERED_TEXT_FIELDS, TEXT_FIELD_CONFIG, TEXT_FIELD_PLACEHOLDERS } =
  constants.cookies.bannerTextOverride

const TextCustomization = () => {
  const classes = useStyles()
  const { setValue, watch } = useFormContext()
  const isCompact = watch('isCompact')
  const {
    bannerTextsOverrides,
    updateBannerTextOverride,
    getBannerTextOverride,
    selectedLanguage,
  } = useCookieBanner()

  const debounceRef = useRef()

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      setValue('bannerTextsOverrides', bannerTextsOverrides, {
        shouldDirty: true,
      })
    }, 300)
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [bannerTextsOverrides, setValue])

  const handleChange = (fieldKey) => (e) => {
    updateBannerTextOverride(fieldKey, e.target.value)
  }

  const getPlaceholder = (fieldKey) => {
    const languagePlaceholders = TEXT_FIELD_PLACEHOLDERS?.[selectedLanguage]
    if (isCompact && languagePlaceholders?.compact?.[fieldKey])
      return languagePlaceholders.compact[fieldKey]
    return languagePlaceholders?.[fieldKey]
  }

  return (
    <Grid container spacing={2} className={classes.textCustomizationContainer}>
      <Grid item xs={12}>
        <LanguageCustomization />
        <Alert severity="info" className={classes.alert}>
          Ajuste os textos exibidos no banner para este idioma. Para manter o
          padrão, deixe os campos em branco.
        </Alert>
      </Grid>

      {ORDERED_TEXT_FIELDS.map((fieldKey) => {
        const config = TEXT_FIELD_CONFIG[fieldKey]
        if (!config) return null
        if (config.mobileField)
          return (
            <Grid item xs={4} key={fieldKey}>
              <ButtonTextFields
                label={config.label}
                desktopField={fieldKey}
                mobileField={config.mobileField}
                desktopMaxLength={config.maxLength}
                desktopPlaceholder={getPlaceholder(fieldKey)}
                mobilePlaceholder={getPlaceholder(config.mobileField)}
              />
            </Grid>
          )
        return (
          <Grid item xs={12} key={fieldKey}>
            <TextField
              fullWidth
              label={config.label}
              value={getBannerTextOverride(fieldKey)}
              onChange={handleChange(fieldKey)}
              multiline={config.multiline}
              minRows={config.multiline ? 4 : 1}
              InputLabelProps={{ shrink: true }}
              placeholder={getPlaceholder(fieldKey)}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}

export default TextCustomization
